import React, { useState } from "react";
import "./Reason_cancelling_field_holder.css";
import { Form } from "react-bootstrap";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import Gray_Btn from "../common_btn/gray_btn/Gray_Btn";
// import Success_Modal from '../common_modal/success_modal/Success_Modal'
import { useNavigate } from "react-router-dom";
import Successfull_Modal from "../../Common_modal/Successfull_Modal/Successfull_Modal";
import Success_Modal_2 from "../../Common_modal/success_modal2/Success_Modal_2";
import { postCancelOrder } from "../../../utils/apis/orderProcess/orderProcess";

function Reason_cancelling_field_holder({
  ReasonId,
  selectedReason,
  setRemark,
  Remark,
  order,
  onSubmit,
  navigate,
  showSuccessModal,
  setShowSucsessModal,
  text
}) {
  return (
    <>
      <section className="Reason_cancelling_field_holder">
        <Form
          onSubmit={(e) => {
            e.preventDefault(); 
            onSubmit();
          }}
        >
          <Form.Group className="input_group mb-3">
            <Form.Label>
              Could you tell us a reason for {text}? (optional)
            </Form.Label>

            <Form.Control
              as="textarea"
              placeholder="Type a reason"
              rows={1}
              value={Remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Form.Group>

          <div className="btn_holder">
            <Green_Btn
              btn_name={"Submit"}
              type={"submit"} // ✔ ok now
            />

            <Gray_Btn
              btn_name={"Cancel"}
              onClick={() => navigate(`/order-details/${order?.id}`)}
            />
          </div>
        </Form>
      </section>

     
    </>
  );
}

export default Reason_cancelling_field_holder;
